import { useTranslation } from "react-i18next";
import { PMDialog } from "../../utils/PMDialog";
import { TripletexSyncWarning } from "./tripletex-sync-warning";

export function TripletexSyncDialog({ open, onClose, sync, onRetry }) {
  const { t } = useTranslation();
  const title = sync?.title || "tripletex_sync.title_default";
  const isSynced = sync?.state === "synced";

  return (
    <PMDialog
      open={open}
      onClose={onClose}
      title={title}
      size="md"
      closeOnOutsideClick
    >
      <div className="px-4 pb-4 sm:px-1 sm:pb-1">
        {isSynced ? (
          <p className="text-sm text-slate-600">{t("tripletex_sync.dialog.synced_body")}</p>
        ) : (
          <TripletexSyncWarning sync={sync} onRetry={onRetry} hideTitle />
        )}
      </div>
    </PMDialog>
  );
}

export default TripletexSyncDialog;
